import * as React from 'react';
import {
    Typography, AccordionSummary, AccordionDetails, Stack, Divider, Card, CardContent, IconButton, Grid, Accordion,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Popover, Link, Box
} from '@mui/material'

import { LeaderboardLine } from 'pages/leaderboard/leaderboard';
import constants from 'assets/constants';
import ShadowBox from 'components/ShadowBox';
import { useTranslation } from "react-i18next";

const leaderboards = constants["LEADERBOARD"]

export default ({data}) => {

    const { t } = useTranslation();

    const visibleLeaderboards = data["leaderboard"]
        .sort((a, b) => a["rank"] - b["rank"])
        .filter((el) => leaderboards.some((el2) => el2.tag === el["leaderboard"]));

    if (visibleLeaderboards.length === 0) {
      return null;
    }

    return  <>
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{mt: 5}}
    >
      <Typography variant="h6" fontWeight="bold" color="text.primary_bold" component="div" sx={{mb: 2}}>
        {t("leaderboardCard.title")}
      </Typography>
    </Stack>

          {visibleLeaderboards.map(el => {
            const filtered = leaderboards.filter(el2 => el2.tag == el["leaderboard"])

          return filtered.length > 0 ? <ShadowBox key={el["leaderboard"]} sx={{mt: 1, border: (theme) => '1px solid ' + theme.palette.primary.main, overflow: "hidden"}}>
                <Box backgroundColor="primary.main" sx={{py: 1, px: 1.5}}>
                    <Typography color="common.white" variant="body1" fontWeight="bold">
                        {t("leaderboards." + filtered[0].tag + ".name")} {el?.category ? t("filters.pyramid." + el["category"]).toLowerCase() : ""}
                    </Typography>
                </Box>
                <LeaderboardLine dense={true} rank={el["rank"]+1} id={el["id"]} title={data["name"]} subtitle={data["club"]} value={filtered[0].value(el)}/>
          </ShadowBox> : null })}
      
    </>
}